import React from 'react'

interface EnergyContextType {
    energyIds: number[] | null
    setEnergyIds: React.Dispatch<React.SetStateAction<number[] | null>>
   
}

const EnergyContext = React.createContext<EnergyContextType | null>(null)

export const  useEnergyContext =  () => {
    const context = React.useContext(EnergyContext);
    if (context == null) {
      throw new Error('useEnergyContext must be used within a EnergyProvider');
    }
    return context;
}
const EnergyProvider = ({ children }: { children: React.ReactNode }) => {
    const [energyIds, setEnergyIds] = React.useState<number[] | null>(null)
  return (
    <EnergyContext.Provider value={{
        energyIds,
        setEnergyIds
    }}>
      {children}
    </EnergyContext.Provider>
  )
}

export default EnergyProvider